import { render, staticRenderFns } from "./AddAoaiKeyVault.vue?vue&type=template&id=51dde8ad&scoped=true"
import script from "./AddAoaiKeyVault.vue?vue&type=script&lang=js"
export * from "./AddAoaiKeyVault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dde8ad",
  null
  
)

export default component.exports